import { useState } from 'react';
import { Collapse, List, ListItemButton, ListItemText } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

function NavigationItem({ item, onNavigate, depth = 0 }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ListItemButton
        sx={{ pl: 2 + depth * 2 }}
        onClick={() => (item.children ? setOpen(!open) : onNavigate(item.href))}
        aria-expanded={item.children ? open : undefined}
      >
        <ListItemText primary={item.label} />
        {item.children && (open ? <ExpandLess /> : <ExpandMore />)}
      </ListItemButton>
      {item.children && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.children.map((child) => (
              <NavigationItem
                key={child.href || child.label}
                item={child}
                onNavigate={onNavigate}
                depth={depth + 1}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
}

export default function Navigation({ items, onNavigate }) {
  return (
    <List>
      {items.map((item) => (
        <NavigationItem
          key={item.href || item.label}
          item={item}
          onNavigate={onNavigate}
        />
      ))}
    </List>
  );
}
